import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TagType } from 'common/enums/api.enums';
import { selectIsUserLoggedIn } from 'modules/authentication/state/selectors';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';
import useRootSelector from 'common/hooks/useRootSelector';
import notificationApi from 'api/userNotification.api';
import mpNotificationApi from 'memberPortalApi/userNotification.api';

export const useNotificationsHandler = (): (() => void) => {
  const dispatch = useDispatch();
  const isClientPortalUserLoggedIn: boolean = useRootSelector(selectIsUserLoggedIn);
  const isMemberPortalUserLoggedIn: boolean = useRootSelector(selectIsMemberPortalUserLoggedIn);

  return useCallback(() => {
    if (isClientPortalUserLoggedIn) {
      dispatch(notificationApi.util.invalidateTags([TagType.UserNotificationsCount]));
    } else if (isMemberPortalUserLoggedIn) {
      dispatch(mpNotificationApi.util.invalidateTags([TagType.MemberPortalUserNotificationsCount]));
    }
  }, [dispatch, isClientPortalUserLoggedIn, isMemberPortalUserLoggedIn]);
};
